// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"63":"9dd620a7cb6a56962434","178":"231f5ab9942c68b238ff","187":"87c9994a7857916f2634"}[chunkId] + ".js";
};